var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzureRedis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a32",
    x1: 9.5,
    y1: 7.37,
    x2: 17.5,
    y2: 7.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005ba1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#0060a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#0071c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005ba1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b32",
    x1: 0.5,
    y1: 7.37,
    x2: 8.5,
    y2: 7.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005ba1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#0060a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#0071c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005ba1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c32",
    x1: 5,
    y1: 11.9,
    x2: 13,
    y2: 11.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005ba1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#0060a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#0071c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005ba1"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 4.62c-2.21 0-4-.57-4-1.28v6.79c0 .69 1.76 1.26 3.95 1.27h.05c2.21 0 4-.57 4-1.27V3.34c0 .71-1.79 1.28-4 1.28z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 3.34c0 .71-1.79 1.28-4 1.28s-4-.57-4-1.28 1.79-1.27 4-1.27 4 .57 4 1.27",
    fill: "#e8e8e8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.57 3.24c0 .45-1.38.81-3.07.81s-3.07-.36-3.07-.81 1.38-.81 3.07-.81 3.07.36 3.07.81",
    fill: "#50e6ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3.43a8.65 8.65 0 00-2.43.3 7.8 7.8 0 002.43.32 7.8 7.8 0 002.43-.32 8.65 8.65 0 00-2.43-.3z",
    fill: "#32bedd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4.62c-2.21 0-4-.57-4-1.28v6.79c0 .69 1.76 1.26 4 1.27 2.21 0 4-.57 4-1.27V3.34c0 .71-1.79 1.28-4 1.28z",
    fill: "url(#b)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3.34c0 .71-1.79 1.28-4 1.28s-4-.57-4-1.28 1.79-1.27 4-1.27 4 .57 4 1.27",
    fill: "#e8e8e8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57 3.24c0 .45-1.38.81-3.07.81s-3.07-.36-3.07-.81 1.38-.81 3.07-.81 3.07.36 3.07.81",
    fill: "#50e6ff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3.43a8.65 8.65 0 00-2.43.3 7.8 7.8 0 002.43.32 7.8 7.8 0 002.43-.32 8.65 8.65 0 00-2.43-.3z",
    fill: "#32bedd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.15c-2.21 0-4-.57-4-1.28v6.79c0 .7 1.76 1.26 3.95 1.27H9c2.21 0 4-.57 4-1.27V7.87c0 .71-1.79 1.28-4 1.28z",
    fill: "url(#c)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13 7.87c0 .71-1.79 1.28-4 1.28s-4-.57-4-1.28S6.79 6.6 9 6.6s4 .57 4 1.27",
    fill: "#e8e8e8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.07 7.77c0 .45-1.38.81-3.07.81s-3.07-.36-3.07-.81S7.31 7 9 7s3.07.36 3.07.81",
    fill: "#50e6ff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8a8.65 8.65 0 00-2.43.3A7.8 7.8 0 009 8.58a7.8 7.8 0 002.43-.32A8.65 8.65 0 009 8z",
    fill: "#32bedd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureRedis);
export default __webpack_public_path__ + "static/media/azure-redis.0dea4e828dd5c1e0dfc78d55d78cd026.svg";
export { ForwardRef as ReactComponent };